import { Input } from "@sablier/v2-components/organisms";
import { useT } from "@sablier/v2-locales";
import { _ } from "@sablier/v2-mixins";
import { useFieldDays, useFieldHours, useFieldYears } from "../logic";

function Years() {
  const { t } = useT();
  const { years, onChange } = useFieldYears();
  return (
    <Input.AmountStepper
      id={years.field.id}
      min={1}
      max={30}
      isEditable
      measure={years.field.value === "1" ? t("words.year") : t("words.years")}
      onChange={onChange}
      placeholder={"0"}
      value={years.field.value}
    />
  );
}

function Days() {
  const { t } = useT();
  const { days, onChange } = useFieldDays();
  return (
    <Input.AmountStepper
      id={days.field.id}
      min={1}
      max={364}
      isEditable
      measure={days.field.value === "1" ? t("words.day") : t("words.days")}
      onChange={onChange}
      placeholder={"0"}
      value={days.field.value}
    />
  );
}

function Hours() {
  const { t } = useT();
  const { hours, onChange } = useFieldHours();
  return (
    <Input.AmountStepper
      id={hours.field.id}
      min={1}
      max={23}
      isEditable
      measure={hours.field.value === "1" ? t("words.hour") : t("words.hours")}
      onChange={onChange}
      placeholder={"0"}
      value={hours.field.value}
    />
  );
}

const Fields = {
  Years,
  Days,
  Hours,
};

export default Fields;
